import React, { Dispatch } from "react";

import { Grid } from "@mui/material";
import { ChoosePrices } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/PricesTab/ChoosePrices";
import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/subscriptionReducer";

interface ProductTabProps {
  index: number;

  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}
export const PricesTab = ({
  index,
  payload,
  dispatchPayload,
}: ProductTabProps) => {
  return (
    <Grid container direction={"column"} rowSpacing={2} mt={2}>
      <ChoosePrices
        index={index}
        payload={payload}
        dispatchPayload={dispatchPayload}
      />
    </Grid>
  );
};
